














































































































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';

import { InternacaoNovaFormData } from '../../../../back/src/types';
import { Paciente } from '../../../../back/src/entity/Paciente';

import Confirmar from '../Confirmar.vue';
import { internacaoLocalItens, internacaoMotivoItens, localPartoLowerValues } from '../../utils/constants';

export default Vue.extend({
  name: 'TheInternacoesNovaForm',
  components: {
    Confirmar,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
      required: true,
    },
  },
  data: () => ({
    loading: {
      submit: false,
    },
    agendamento: false,
    menuAgendamentoData: false,
    menuInternacaoData: false,
    form: {
      local: null,
      localOutro: null,
      quarto: null,
      motivo: null,
      motivoOutro: null,
      datetimeAgendamentoData: null,
      datetimeAgendamentoHorario: null,
      datetimeInternacaoData: null,
      datetimeInternacaoHorario: null,
    },
    rules: {
      required: [
        (v: string) => !!v || 'Campo obrigatório',
      ],
      hora: [
        (v: string) => !!v || 'Campo obrigatório',
        (v: string) => {
          const timePattern: RegExp = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
          return (v && timePattern.test(v)) || 'Horário inválido';
        },
      ],
    },
    items: {
      local: internacaoLocalItens,
      motivo: internacaoMotivoItens,
    },
  }),
  computed: {
    dataAgendamentoFormatada(): string {
      if (this.form.datetimeAgendamentoData) {
        const momentData = moment(this.form.datetimeAgendamentoData);
        if (momentData.isValid()) {
          return momentData.format('DD/MM/YYYY');
        }
      }
      return '';
    },
    dataInternacaoFormatada(): string {
      if (this.form.datetimeInternacaoData) {
        const momentData = moment(this.form.datetimeInternacaoData);
        if (momentData.isValid()) {
          return momentData.format('DD/MM/YYYY');
        }
      }
      return '';
    },
    formInternacaoNova():
      Vue & { validate: () => boolean, resetValidation: () => void } {
      return this.$refs.formInternacaoNova as Vue & {
        validate: () => boolean,
        resetValidation: () => void
      };
    },
    confirmar(): Vue & { open: () => boolean } {
      return this.$refs.confirmar as Vue & { open: () => boolean };
    },
  },
  mounted() {
    this.preencheForm();
  },
  methods: {
    preencheForm() {
      const localParto = _.get(this.paciente, 'gestacao_atual.local_parto', '');
      const local = localParto ? _.get(localPartoLowerValues, _.toLower(localParto.trim()), '') : '';
      this.form.local = localParto ? local || 'outro' : null;
      this.form.localOutro = localParto && !local ? localParto : null;
      const now = moment().tz('America/Sao_Paulo');
      this.form.datetimeInternacaoData = now.format('YYYY-MM-DD');
      this.form.datetimeInternacaoHora = now.format('HH:mm');
    },
    limpaForm() {
      this.form = {
        local: null,
        localOutro: null,
        quarto: null,
        motivo: null,
        motivoOutro: null,
        datetimeInicialData: null,
        datetimeInicialHorario: null,
      };
    },
    // eslint-disable-next-line func-names
    cancelarDebounce: _.debounce(async function () { await this.cancelar(); }, 200),
    async cancelar() {
      if (await this.confirmar.open(
        'Cancelar nova internação',
        'Tem certeza que deseja cancelar esta nova internação?\nOs dados preenchidos serão perdidos.',
      ) === false) {
        return;
      }
      this.$emit('cancelar');
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading.submit = true;
      if (!this.formInternacaoNova.validate()) {
        this.loading.submit = false;
        return;
      }
      const datetimeInicial = this.agendamento
        ? moment(`${this.form.datetimeAgendamentoData} ${this.form.datetimeAgendamentoHora}`)
        : moment(`${this.form.datetimeInternacaoData} ${this.form.datetimeInternacaoHora}`);
      if (!datetimeInicial.isValid()) {
        this.loading.submit = false;
        return;
      }
      const formData: InternacaoNovaFormData = {
        paciente_id: this.paciente.id,
        gestacao_id: _.get(this.paciente, 'gestacao_atual.id', null),
        local: this.form.local === 'outro' ? this.form.localOutro : this.form.local,
        quarto: this.form.quarto,
        motivo: this.form.motivo === 'outro' ? this.form.motivoOutro : this.form.motivo,
        datetime_agendamento: this.agendamento ? datetimeInicial.toDate() : null,
        datetime_internacao: this.agendamento ? null : datetimeInicial.toDate(),
      };
      try {
        const response = await Requester.internacao.criaInternacao(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Nova internação registrada com sucesso.' });
          this.limpaForm();
          this.formInternacaoNova.resetValidation();
          this.$emit('nova-internacao', response.data);
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
  },
});
